export const FeedbackTopic = {
  PRODUCT: 'product',
  DEVELOPER_EXPERIENCE: 'developer-experience',
  INTEGRATION_EXPERIENCE: 'integration-experience',
  PERFORMANCE_RELIABILITY: 'performance-reliability',
  DOCUMENTATION_LEARNING: 'documentation-learning',
  FEATURE_REQUEST: 'feature-request',
  BUG_REPORT: 'bug-report',
  OTHER: 'other',
} as const
